import { EntDirectoryInfoName } from '../directoryInfoName'

export class EntTypesOfProduct {
    id: number | null = null;
    nameKy: string | null = null;
    nameRu: string | null = null;
    productCategoryId?: number | null = null;
    productCategory?: EntTypesOfProduct | null = null;
    children?: { nameKy: string; nameRu: string }[] = [];
}

export class EntTypesOfProductCompany {
    companyName: string | null = null
    id: number | null = null
}
